export enum PlanFeaturesType {
    aimessaging = 'aimessaging',
    app_mobile = 'app_mobile',
    credits_mechanism = 'credits_mechanism',
    record_incoming_calls = 'record_incoming_calls',
    voicemail_recording = 'voicemail_recording',
    notify_missed_calls = 'notify_missed_calls',
}